module.exports = __webpack_public_path__ + "static/media/search.20eb2e92.svg";